/*
 * Copyright (c) 2020. American Express Company
 */

// third-party
import React, { Component, ReactComponentElement } from 'react';

// models and services
import LiteralsService from '../../services/literals/LiteralsService';

// components
import GoalDrawer from './GoalDrawer';
import JobPicker from '../job-picker/JobPicker';
import SalaryInput from '../salary-input/SalaryInput';

// icons and styles
import { ReactComponent as LadderIcon } from 'src/bw/goal/ladder.svg';
import { HELP_DOMAIN } from 'src/utils/constants';

export default class JobDeltaDrawer extends Component<any, any> {
    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;
        const incomeSources = this.props.validIncomeSources(drawerProps.card, drawerProps.incomeSources);

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                handleUpdateCard={this.props.handleUpdateCard}
                handleChangeCard={this.props.handleChangeCard}
                handleDeleteCard={this.props.handleDeleteCard}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                icon={<LadderIcon />}
                introContent={
                    <>
                        {LiteralsService.getLiteral('JobDeltaDrawer.intro')}
                        <br />
                        <br />
                        {LiteralsService.getLiteral('JobDeltaDrawer.intro2')}
                    </>
                }
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                learnMoreContent={LiteralsService.getJsxLiteral('JobDeltaDrawer.introLink')}
                learnMoreUrl={HELP_DOMAIN ? `${HELP_DOMAIN}/articles/income` : null}
            >
                <SalaryInput
                    card={drawerProps.card}
                    handleChangeCardAttribute={this.props.handleChangeCardAttribute}
                    calloutText={LiteralsService.getLiteral('JobDeltaDrawer.takeHome')}
                />

                <JobPicker
                    label={LiteralsService.getLiteral('JobDeltaDrawer.incomeSourceLabel')}
                    value={drawerProps.card.modifyIncomes[0] || ''}
                    onChange={({ target: { value } }: { target: { value: string } }) => {
                        this.props.handleChangeCard(drawerProps.card, value, 'modifyIncomes');
                    }}
                    incomeSources={incomeSources}
                    hasInvalidIncome={drawerProps.card.warnings?.length > 0}
                />
            </GoalDrawer>
        );
    }
}
